import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';

@Component({
  selector: 'amazon',
  templateUrl: './amazon.component.html',
  styleUrls: ['./amazon.component.scss']
})
export class AmazonComponent implements OnInit, OnDestroy {
  public enabled: boolean;
  public authFailed = false;
  public existingIntegrations = [];
  public creating = false;
  oauthURL = '';
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiHelper: ApiHelper,
    public dialogRef: MatDialogRef<AmazonComponent>,
    private integrationDao: IntegrationDao
  ) {
    this.authFailed = false;
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
      this.noAccounts = true;
    }
    // this.integrationDao.getAmazonRedirUrl().subscribe(res => {
    //   this.oauthURL = res.redirUrl;
    // });
  }

  ngOnInit() {}

  ngOnDestroy() {}

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  handleLogin(e) {
    if (!this.oauthURL) {
      console.error('OAuth URL not loaded');
      return false;
    }
    const clientId = 'amzn1.application-oa2-client.3cae9d1ae5b244758b44e83ed25d034b';
    const scope = 'cpc_advertising:campaign_management';
    const redirectUrl = this.oauthURL;
    const url = `https://www.amazon.com/ap/oa?client_id=${clientId}&response_type=code&scope=${scope}&redirect_uri=${redirectUrl}&state=${this.data.brand}`;
    let opened = window.open(
      url,
      null,
      'width=450,height=600,menubar=0,toolbar=0,location=0,personalbar=0,statusbar=0,top=100,left=100,alwaysRaised=yes'
    );

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'amazon' && event.data.id !== undefined) {
          this.integrationDao.loadById(event.data.id).subscribe(created => {
            this.dialogRef.close(created);
          });

          // remove listener
          window.removeEventListener('message', listener);

          // close window
          opened.close();
        } else {
          this.authFailed = true;
        }
      } else {
        this.authFailed = true;
      }
    }

    window.addEventListener('message', listener);
  }
}
